import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getUser,
  getOverduePurchases,
  getDefaultPaymentMethod,
  getRenewalUnpaid,
  getCurrentCycle,
  getRenewalPurchase,
} from 'reducers';
import { getAll as getAllPurchases } from 'billing/purchases/actions';
import { getAll as getAllPaymentMethods } from 'billing/paymentMethods/actions';
import { fetch as fetchCycles } from 'billing/cycles/actions';
import { getAttAllocations, getQuickAllocations, clearAllocations, checkRenewal } from 'billing/renewal/actions';
import { daysLeftInCycle } from 'billing/cycles/utils';

import CurrentDue from './CurrentDue';

class CurrentDueContainer extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if ( this.props.userId !== oldProps.userId ) {
      this.fetchData();
    }
  }

  fetchData() {
    const {
      getAllPurchases,
      getAllPaymentMethods,
      userId,
      fetchCycles,
      getAttAllocations,
      getQuickAllocations,
      clearAllocations,
      checkRenewal
    } = this.props;

    if (!userId) { return; }
    getAllPurchases(userId);
    getAllPaymentMethods(userId);
    fetchCycles();
    clearAllocations();
    getAttAllocations(userId);
    getQuickAllocations(userId);
    checkRenewal(userId);
  }

  render() {
    return <CurrentDue {...this.props} />
  }
}

const mapStateToProps = (state) => {
  const cycle = getCurrentCycle(state);
  return {
    user: getUser(state),
    userId: getUser(state) && getUser(state).id,
    overduePurchases: getOverduePurchases(state),
    paymentMethod: getDefaultPaymentMethod(state),
    renewalUnpaid: getRenewalUnpaid(state),
    renewalPurchase: getRenewalPurchase(state),
    daysLeftInCycle: cycle ? daysLeftInCycle(cycle.end_date) : null,
    currentCycle: cycle,
  }
};

const mapDispatchToProps = {
  getAllPurchases,
  getAllPaymentMethods,
  fetchCycles,
  getAttAllocations,
  getQuickAllocations,
  clearAllocations,
  checkRenewal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentDueContainer);
